<template>
    <!--https://cssloaders.github.io/-->
    <!-- <span class="loader"></span> -->
    <div class="lds-dual-ring"></div>
</template>

<style lang="scss">
/**
 * https://cssloaders.github.io/
 */
// .loader {
//     width: 48px;
//     height: 48px;
//     border-radius: 50%;
//     display: inline-block;
//     position: relative;
//     border: 3px solid;
//     border-color: #FFF #FFF transparent transparent;
//     box-sizing: border-box;
//     animation: rotation 1s linear infinite;
// }

// .loader::after,
// .loader::before {
//     content: '';
//     box-sizing: border-box;
//     position: absolute;
//     left: 0;
//     right: 0;
//     top: 0;
//     bottom: 0;
//     margin: auto;
//     border: 3px solid;
//     border-color: transparent transparent #FF3D00 #FF3D00;
//     width: 40px;
//     height: 40px;
//     border-radius: 50%;
//     box-sizing: border-box;
//     animation: rotationBack 0.5s linear infinite;
//     transform-origin: center center;
// }

// .loader::before {
//     width: 32px;
//     height: 32px;
//     border-color: #FFF #FFF transparent transparent;
//     animation: rotation 1.5s linear infinite;
// }

// @keyframes rotation {
//     0% {
//         transform: rotate(0deg);
//     }

//     100% {
//         transform: rotate(360deg);
//     }
// }

// @keyframes rotationBack {
//     0% {
//         transform: rotate(0deg);
//     }

//     100% {
//         transform: rotate(-360deg);
//     }
// }


.lds-dual-ring {
    display: inline-block;
    width: 80px;
    height: 80px;
}

.lds-dual-ring:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>